export const getMainSiteUrl = (url) => {
    try {
        const link = new URL(url);
        return `${link.protocol}//${link.hostname}`;
    } catch (e) {
        return '';
    }    
}